import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { UsState } from './model';
import { getUSState } from './thunks';

const initialState: UsState = {
  usState: [],
};

const usStateSlice = createSlice({
  name: 'usState',
  initialState,
  reducers: {
    setUSState: (state, action: PayloadAction<UsState['usState']>) => {
      state.usState = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getUSState.fulfilled, (state, action) => {
      state.usState = action.payload;
    });
  },
});

export const { setUSState } = usStateSlice.actions;
export default usStateSlice.reducer;
